export let relatedProductsTable = ($) => {
// Related Products "Add"
  $('body').on('click', '#related-products .add-product-label', function(event) {
    event.preventDefault();
    $('#compare-products-column').val($(this).attr('data-column'));
    $.magnificPopup.open({
      items: {
        src: '#modal-compare-add',
        type: 'inline'
      },
      callbacks: {
        open: function() {
          $('#modal-compare-add .error').hide();
          $('#modal-compare-add .loading-spinner').hide();
        }
      }
    });
  });

// Related Proudcts "Remove"
  $('body').on('click', '#related-products .remove-product-label', function(event) {
    event.preventDefault();
    if ($(this).hasClass('click-disabled')) {
      alert('Please use the last column');
      return
    }
    var thisProductLabel = $(this),
      dataColumnId = thisProductLabel.data('column'),
      currentProd = thisProductLabel.data('current-prod'),
      cells = $('.data-column-' + dataColumnId),
      addProductLabel = '<span class="fa fa-plus-circle"></span><br>Add Product';
      $('#choose-compare-products option[value="' + currentProd + '"]').removeAttr('disabled');
    // Set Label
    thisProductLabel.html(addProductLabel).removeClass('remove-product-label').addClass('add-product-label');

    // Set cells to blank
    $.each(cells, function(item) {
      $(this).text('');
    });

    // Re-enable option in modal select box
    //thisProductLabel.removeAttr('data-current-prod');
  });

// Add to Compare Button
  $('body').on('click', '#add-to-compare-button', function(event) {
    event.preventDefault();
    $('#modal-compare-add .error').hide();
    $('#modal-compare-add .loading').show();
    var $cell;
    var selectedProductId = $('#choose-compare-products').val(),
      selectedColumn = $('#compare-products-column').val();

    var getProductCompareData = $.ajax({
      url: isolaVars.ajaxurl,
      data: {
        action: 'isola_prodcomp_get_prod_data',
        prod_id: selectedProductId,
      },
      dataType: 'json'
    });
    getProductCompareData.done(function(data) {
      $('#modal-compare-add .loading').hide();
      if (data.result === 'success') {
        $('th[data-column="' + selectedColumn + '"]').html('<span class="fa fa-minus-circle"></span><br>' + data.product_title).removeClass('add-product-label').addClass('remove-product-label').attr('data-current-prod', selectedProductId);
        for (var key in data.comparison_data) {
          if (data.comparison_data.hasOwnProperty(key)) {
            var field_value = data.comparison_data[key].value;
            if (field_value === true) field_value = '<span class="fa fa-check"></span>';
            if (field_value === false) field_value = '<span class="fa fa-close"></span>';
            $cell = $('tr[data-compare-field="' + key + '"] td.data-column-' + selectedColumn);
            if (field_value.constructor === Array) {
              for (j = 0; j < field_value.length; j++) {
                $cell.append('<div>' + field_value[j] + '</div>');
              }
            } else {
              $cell.html(field_value.replace('{BR}', ''));
            }
          }
        }
        $('#choose-compare-products').val('');
        $('#choose-compare-products option[value="' + selectedProductId + '"]').attr('disabled', 'disabled');
        $.magnificPopup.close();
      } else {
        $('#modal-compare-add .error').show();
      }
    });
  });
}
